<p-dialog
  [(visible)]="dialogVisible"
  [header]="'select.kpis' | transloco"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{width: '90vw'}"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  appendTo="body"
>
  <div class="flex justify-content-between pt-4 pb-3">
    <div class="flex">
      <span class="p-float-label">
        <input
          [(ngModel)]="currentFilters.name"
          (keyup.enter)="applyFilters()"
          type="text"
          id="name"
          pInputText
        >
        <label for="name">{{'attribute.name' | transloco}}</label>
      </span>
      <span class="p-float-label ml-2">
      <input
        [(ngModel)]="currentFilters.description"
        (keyup.enter)="applyFilters()"
        type="text"
        id="description"
        pInputText
      >
      <label for="description">{{'attribute.description' | transloco}}</label>
    </span>
    <span class="p-float-label ml-2 w-16rem" *ngIf="('ROLE_ADMIN' | userHasRole: false) && !organization && organizations">
      <p-multiSelect
        *ngIf="organizations"
        [(ngModel)]="currentFilters.organizationUuids"
        [styleClass]="'w-full'"
        [options]="organizations"
        [filter]="true"
        optionLabel="name"
        optionValue="uuid"
        inputId="organization"
        display="chip"
        appendTo="body"
      ></p-multiSelect>
      <label>{{'model.organization' | transloco}}</label>
    </span>
    </div>
    <div>
      <button
        [label]="'common.search' | transloco"
        (click)="applyFilters()"
        pButton
        icon="pi pi-search"
        iconPos="right"
      ></button>
    </div>
  </div>

  <p-table
    [(selection)]="selectedKpis"
    [(first)]="first"
    [(rows)]="rows"
    [value]="kpiList"
    [totalRecords]="totalKpis"
    [paginator]="true"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [autoLayout]="true"
    [sortField]="currentFilters.sortField"
    [sortOrder]="currentFilters.sortOrder"
    [lazy]="true"
    (onLazyLoad)="onKpiPageChange($event)"
    (selectionChange)="kpisChange.emit($event)"
    responsiveLayout="stack"
    styleClass="p-datatable-striped"
    dataKey="uuid"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="w-3rem">
          <button
            (click)="displaySelectAllDialog()"
            pButton
            pRipple
            icon="pi pi-check-square"
            class="p-button-icon-only p-button-text p-0 w-auto p-button-lg"
          ></button>
        </th>
        <th pSortableColumn="name">
          {{'attribute.name' | transloco}}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="organization.name">
          {{'model.organization' | transloco}}
          <p-sortIcon field="organization.name"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-kpi>
      <ng-component *ngIf="!hasBeenOpened || loadingKpis then skeletonRow else dataRow"></ng-component>
      <ng-template #dataRow>
        <tr>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'common.select' | transloco}}</span>
            <p-tableCheckbox [value]="kpi"></p-tableCheckbox>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
            <p class="text-right md:text-left">{{kpi.name}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
            <p class="text-right md:text-left">{{kpi.description}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
            <p class="text-right md:text-left">{{kpi.organization?.name}}</p>
          </td>
        </tr>
      </ng-template>
      <ng-template #skeletonRow>
        <tr>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
          <td class="h-3rem py-0">
            <p-skeleton height="1em"></p-skeleton>
          </td>
        </tr>
      </ng-template>
    </ng-template>
  </p-table>

  <div class="flex justify-content-between mt-3">
    <button
      [label]="'common.cancel' | transloco"
      (click)="closeWithoutSaving()"
      pButton
      class="mr-2 p-button-danger"
    ></button>
    <button
      *ngFor="let actionButton of actionButtons"
      [label]="actionButton.label | transloco"
      [class.p-button-danger]="selectedKpis.length > 100"
      [pTooltip]="'error.tooMany.kpis' | transloco"
      [tooltipDisabled]="selectedKpis.length <= 100"
      [disabled]="!selectedKpis || selectedKpis.length === 0"
      [icon]="actionButton.icon"
      (click)="selectedKpis.length <= 100 ? actionButton.action(selectedKpis) : ''"
      pButton
      class="mr-2"
      iconPos="right"
    ></button>
  </div>

</p-dialog>
